import styled from "styled-components";

export const BodyWrapper = styled.tbody`
  padding: 0 18px 0 24px;
  background-color: #fff;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
`;

export const TableRow = styled.tr`
  width: 100%;
  display: flex;
`;

export const Table = styled.table`
  width: 100%;
`;

export const Body = styled.tr`
  padding: 24px 0 20px 0;
  display: flex;
  align-items: flex-start;
  border-bottom: 1px solid #eaeaea;

  &:last-child {
    border-bottom: 0;
  }
`;

export const Title = styled.h2`
  padding-top: 4rem;
  font-family: 'Rubik';
  font-size: 18px;
  font-weight: 600;
`;

export const Header = styled.thead`
  margin-top: 3rem;
  border-radius: 12px;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  background-color: #d1e5ff;
  font-family: 'Rubik';
  font-size: 14px;
  font-weight: 600;
  color: #141823;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
`;

export const RouteColumn = styled.td`
  width: 20%;
  display: flex;
  align-items: center;
`;

export const RouteColumnWrapper = styled.div`
  padding-left: 18px;
  font-family: 'Rubik';
  font-size: 12px;
  font-weight: 600;
`;

export const commonColumn = styled.td`
  width: 10%;
  display: flex;
`;

export const perKmChargeColumn = styled.td`
  width: 14%;
  display: flex;
`

export const ModelColumn = styled.td`
  width: 28%;
  display: flex;
`

export const CTAColumn = styled.td`
  text-align: center;
  width: 18%;
  color: #008CFF;
  cursor: pointer;
`;
